export default {
    list(state) {
        return state.list;
    },
    page(state) {
        return state.page;
    }
}